import React from "react";
import GatsbyImage, { FluidObject, GatsbyImageProps } from "gatsby-image";
import styled from "styled-components";
import { WideContainer } from "../../../shared/components/WideContainer";

export interface TaskTemplateServiceTextModuleProps {
  textModuleDescription?: string;
  textModuleImage?: FluidObject;
  textModuleSectionTitle?: string;
}

export function TaskTemplateServiceTextModule({
  textModuleDescription,
  textModuleImage,
  textModuleSectionTitle,
}: TaskTemplateServiceTextModuleProps) {
  if (textModuleSectionTitle?.length) {
    return (
      <WideContainer>
        <TextModuleInnerRowContainer>
          <TextModuleTitleContainer>
            {textModuleSectionTitle}
          </TextModuleTitleContainer>
          <TextModuleBodyContainer>
            {textModuleDescription && (
              <TextModuleDescriptionContainer
                dangerouslySetInnerHTML={{ __html: textModuleDescription }}
              />
            )}
            {textModuleImage && (
              <TextModuleImageContainer>
                <StyledGatsbyImage fluid={textModuleImage} />
              </TextModuleImageContainer>
            )}
          </TextModuleBodyContainer>
        </TextModuleInnerRowContainer>
      </WideContainer>
    );
  }

  return null;
}

const TextModuleInnerRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2.5rem 0;
  max-width: 1250px;
  position: relative;
  align-items: center;

  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    min-width: 900px;
    align-items: flex-start;
  }
`;

const TextModuleTitleContainer = styled.h2`
  font-size: ${(props) => props.theme.typography.typeScale[400]};
  font-weight: ${(props) => props.theme.typography.weight.extraBold};
  padding-bottom: 1.5rem;
  text-align: center;

  ${(props) => props.theme.breakpoints.desktopUp} {
    font-size: ${(props) => props.theme.typography.typeScale[400]};
  }

  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    text-align: left;
  }
`;

const TextModuleBodyContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column-reverse;
  align-items: center;

  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    flex-direction: row;
    align-items: initial;
  }
`;

const TextModuleDescriptionContainer = styled.div`
  background-color: ${(props) => props.theme.color.white};
  color: ${(props) => props.theme.color.textLabelValue};
  flex-shrink: 3;
  max-width: 682px;
  overflow: hidden;
  padding: 1.5rem;
  width: 80%;
  margin-right: 0;

  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    width: initial;
    margin-right: 2rem;
  }

  & * {
    font-size: ${(props) => props.theme.typography.typeScale[100]};
    font-weight: ${(props) => props.theme.typography.weight.regular};
    list-style-type: disc;
    list-style-position: inside;
  }

  & * ${(props) => props.theme.breakpoints.desktopUp} {
    font-size: ${(props) => props.theme.typography.typeScale[200]};
  }

  & strong {
    font-weight: ${(props) => props.theme.typography.weight.semiBold};
  }
`;

const TextModuleImageContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  width: 80%;
  max-width: 366px;
  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    width: 464px;
    max-width: initial;
  }
`;

const StyledGatsbyImage = styled(GatsbyImage)<GatsbyImageProps>`
  max-width: 100%;
  height: auto;
  width: 100%;
`;
